import React, { useState } from 'react'
import { NoRecords, PageLoader } from '../../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TablePagination } from '@mui/material';
import moment from 'moment';
import { DepositHistory } from '../api/index';
import { Search, ArrowUp, ArrowDown, Copy, Check, ExternalLink } from 'lucide-react';
import { useDebounce } from '../../../hooks/debounce';
import { formatAddress } from '../../../utils/formatAddress';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useModalContext } from '../../../contexts/ModalContext';
import { useToast } from '../../../hooks/usetoast';
import { transactionurl } from "../../../lib/transactionurl";


function CoreBNBHistory() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce(search);
    const [double, setDouble] = useState(false);
    const [addressdouble, setAddressdouble] = useState(false);
    const [copy, setCopy] = useState(false);
    const { theme } = useModalContext()
    const toast = useToast();
    const { data: getReferralHistory, isLoading } = DepositHistory({
        page,
        type: "in",
        currency: "bnb",
        network: "binance",
        size: rowsPerPage,
        searchText,
        sortField: "createdAt",
        sortOrder: sortOrder
    })

    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const copytxnhashAddress = async data => {
        setDouble(data._id)
        await copyToClipboard(data.txnHash)
        toast.success("Transaction Hash copied")
        setTimeout(() => {
            setDouble()
        }, 800)
    }

    const CopytoAddress = async data => {
        setAddressdouble(data._id)
        await copyToClipboard(data.to)
        toast.success("Address copied")
        setTimeout(() => {
            setAddressdouble()
        }, 800)
    }

    const copyAddress = async data => {
        setCopy(data._id)
        await copyToClipboard(data.from)
        toast.success("Address copied")
        setTimeout(() => {
            setCopy()
        }, 800)
    }

const getTransactionType = (type) => {
    if (type === "in") return "DEPOSIT";
    if (type === "out") return "WITHDRAW";
    return "TRANSFER";
};

    const renderReferralHistoryTable = () => (
        getReferralHistory?.data?.data?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Type</TableCell>
                                    <TableCell className='text-nowrap' align="center">Amount</TableCell>
                                    <TableCell className='text-nowrap' align="center">From Address</TableCell>
                                    <TableCell className='text-nowrap' align="center">To Address</TableCell>
                                    <TableCell className='text-nowrap' align="center">Txn Hash</TableCell>
                                    <TableCell className='text-nowrap'>Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder(' desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getReferralHistory?.data?.data?.map((row, i) => {
                                    const transactionType = getTransactionType(row?.type);
                                    return (
                                        <TableRow key={row._id || i}>
                                            <TableCell className='text-nowrap' align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                            <TableCell className='text-nowrap' align="center">
                                                {transactionType}
                                            </TableCell>

                                            <TableCell className="text-nowrap" align="center">
                                                {row?.amount ? (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                        {Number.isInteger(row.amount) ? row.amount : row.amount.toFixed(6)}
                                                        {row?.currencyImage && (
                                                            <img
                                                                src={row.currencyImage}
                                                                alt="Currency Icon"
                                                                style={{
                                                                    height: '20px',
                                                                    width: '20px',
                                                                    borderRadius: '50%',
                                                                    verticalAlign: 'middle',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        )}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {formatAddress(row?.from) || "-"}
                                                {copy === row._id ? (
                                                    <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                                ) : (
                                                    <Copy
                                                        onClick={() => copyAddress(row)}
                                                        size={20}
                                                        className='ml-5'
                                                        style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {formatAddress(row?.to) || "-"}
                                                {addressdouble === row._id ? (
                                                    <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                                ) : (
                                                    <Copy
                                                        onClick={() => CopytoAddress(row)}
                                                        size={20}
                                                        className='ml-5'
                                                        style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.txnHash ? (
                                                    <>
                                                        {`${row.txnHash.slice(0, 3)}...${row.txnHash.slice(-3)}`}
                                                        {double === row._id ? (
                                                            <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                                                        ) : (
                                                            <Copy
                                                                onClick={() => copytxnhashAddress(row)}
                                                                size={20}
                                                                className="ml-5"
                                                                style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                                            />
                                                        )}
                                                        <a
                                                            href={transactionurl["bsc"] + row.txnHash}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="ml-2"
                                                        >
                                                            <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                                                        </a>
                                                    </>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>

                                            <TableCell className='text-nowrap'>
                                                {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <TablePagination
                    component="div"
                    count={getReferralHistory?.data?.total || 0}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <section>
            <h4>BNB History</h4>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <div className='col-md-4'>
                        <div className="input-group">
                            <span className="input-group-icon">
                                <Search size={20} color='#aaa9a9' />
                            </span>
                            <input
                                type="text"
                                onChange={(e) => setSearch(e.target.value)}
                                className="form-control"
                                placeholder="Search Txn Hash"
                            />
                        </div>
                    </div>
                </div>
                {isLoading ?
                    <PageLoader />
                    :
                    renderReferralHistoryTable()
                }
            </div>
        </section>
    )
}

export default CoreBNBHistory